<template>
    <div class="subPage">
        <div class="opreation">
        	<mt-field placeholder="请输入手机号" type="tel" v-model="userName"></mt-field>
            <span v-if="showError" class="error">请输入有效的电话号码！</span>
            <div class='flex'>
                <mt-field placeholder="请输入验证码" type="text" v-model="password"></mt-field>
                <mt-button :disabled="getLoginCode" class="get" @click="getCode()">
                  <!--{{ getLoginCode ? this.time : '获取验证码'}}{{ getLoginCode ? 's' : '' }}-->
                  {{btnShowStr}}
                </mt-button>
            </div>
            <span v-if="showPasswordError" class="error">验证码错误！</span>
             <!-- 保存按钮 -->
            <mt-button class="save" @click="login()">绑定</mt-button>
            <Empty />
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Empty from '../comm/Empty';
import { Toast } from 'mint-ui';
const TIME = 60;
export default {
  name: 'PhoneEdit',
  meta:{page:true},
  data() {
    return {
        userName: '',
        password: '',
        showError: false,
        showPasswordError: false,
        intervel: null,
        time: TIME,
        TIME: TIME,
    }
  },
   watch: {
      getLoginCode: function(value) {
          console.log(value);
          if (value) this.runtime()
          if (!value) window.clearInterval(this.intervel);
      },

  },
  computed: {
    ...mapGetters('user', {
        userInfo: 'getUserInfo',
        loginConfig: 'getLoginConfig',
        getLoginCode: 'getLoginCode',
        errorMessage: 'getErrorMessage',
        successMessage: 'getSuccessMessage'
    }),
    btnShowStr () {
      if(this.time == 0 || this.time == this.TIME) {
        return '获取验证码';
      } else {
        return this.time + 's';
      }
    }
  },
  beforeDestroy() {
      this.$store.dispatch('user/getUserInfo');
  },
  methods: {
  	login() {
        // if (!this.getLoginCode) return;
        const reg=/^[1][3,4,5,7,8][0-9]{9}$/;
        if (!reg.test(this.userName)) {
            this.showError = true;
            return;
        } else {
            this.showError = false;
        }
        if (this.password.trim() === '') {
            this.showPasswordError = true;
            return;
        } else {
            this.showPasswordError = false;
        }
        let refer = this.$route.query.refer||'/';
        this.$store.dispatch('user/bindPhone', { phone: this.userName, phoneCode: this.password ,refer:refer})
    },
  	runtime() {
      const self = this;
      self.time--;
      window.clearInterval(this.intervel);
      this.intervel = window.setInterval(function() {
          self.time--;
          console.log(self.time);
          if (self.time <= 0) {
              self.$store.dispatch('user/initLoginCode');
              window.clearInterval(self.intervel);
              self.time = self.TIME;
          }
      }, 1000)
  	},
  	getCode(){
          const reg=/^[1][3,4,5,7,8][0-9]{9}$/;
          if (!reg.test(this.userName)) {
              this.showError = true;
              return;
          } else {
              this.showError = false;
          }
          this.$store.dispatch('user/getLoginCode', { phone: this.userName })
      }
  },
  components: {
    Empty
  }
}
</script>
<style scoped>
	@import '../../assets/css/phoneEdit.css'
</style>



// WEBPACK FOOTER //
// src/components/page/PhoneEdit.vue